"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_items_1 = __importDefault(require("../constants/actions/remote-items"));

var app_1 = __importDefault(require("../constants/actions/app"));

var remote_followed_groups_1 = __importDefault(require("../constants/actions/remote-followed-groups"));

var remote_items_filter_1 = __importDefault(require("../constants/actions/remote-items-filter"));

var remote_item_review_1 = __importDefault(require("../constants/actions/remote-item-review"));

var remote_groups_1 = __importDefault(require("../constants/actions/remote-groups"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

var remote_item_edit_1 = __importDefault(require("../constants/actions/remote-item-edit"));

var UtilsArray = __importStar(require("../utils/array"));

var followed_status_1 = __importDefault(require("../constants/followed-status"));

var remote_item_approve_state_1 = __importDefault(require("../constants/remote-item-approve-state"));

var row_view_type_1 = __importDefault(require("../constants/row-view-type"));

var items_sort_reserved_words_1 = __importDefault(require("../constants/items-sort-reserved-words"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    list: [],
    group: null,
    user_follow_status: followed_status_1.default.IDEL,
    owner_pending_list: [],
    owner_menu_index: 0,
    error_on_get_list: null,
    error_on_add: null,
    error_on_reload: null,
    error_on_contribute: null,
    error_on_resubmit: null,
    error_on_check_follow: null,
    is_loading: false,
    is_reloading: false,
    is_loading_add: false,
    is_loading_contribute: false,
    is_loading_edit: false,
    is_loading_remove: false,
    is_loading_detach: false,
    is_loading_review: false,
    is_loading_resubmit: false,
    is_loading_follow: false,
    is_loading_unfollow: false,
    is_loading_check_follow: false,
    filter_selected: [],
    filter_user_inputs: [],
    query: '',
    view: row_view_type_1.default.REGULAR,
    sort: items_sort_reserved_words_1.default.EDIT_AT,
    quick_filter_options: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case remote_items_1.default.GET_LIST_INIT:
      return Object.assign({}, state, {
        is_loading: true
      });

    case remote_items_1.default.GET_LIST_SUCCESS:
      {
        return Object.assign({}, state, {
          list: UtilsArray.concatAndUnion(state.list, action.list, 'id'),
          group: action.group,
          is_loading: false,
          view: action.view,
          owner_pending_list: action.owner_pending_list,
          quick_filter_options: action.quick_filter_options
        });
      }

    case remote_items_1.default.GET_LIST_FAILURE:
      return Object.assign({}, state, {
        is_loading: false,
        error_on_get_list: action.error
      });

    case remote_items_1.default.GET_FOLLOWED_STATUS_INIT:
      return Object.assign({}, state, {
        is_loading_check_follow: true,
        error_on_check_follow: null
      });

    case remote_items_1.default.GET_FOLLOWED_STATUS_SUCCESS:
      return Object.assign({}, state, {
        is_loading_check_follow: false,
        user_follow_status: action.status
      });

    case remote_items_1.default.GET_FOLLOWED_STATUS_FAILURE:
      return Object.assign({}, state, {
        is_loading_check_follow: false,
        error_on_check_follow: action.error
      });

    case remote_followed_groups_1.default.FOLLOW_INIT:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_follow: true
          });
        } else {
          return state;
        }
      }

    case remote_followed_groups_1.default.FOLLOW_SUCCESS:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_follow: false,
            user_follow_status: followed_status_1.default.FOLLOWED
          });
        } else {
          return state;
        }
      }

    case remote_followed_groups_1.default.FOLLOW_FAILURE:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_follow: false
          });
        } else {
          return state;
        }
      }

    case remote_followed_groups_1.default.UNFOLLOW_INIT:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_unfollow: true
          });
        } else {
          return state;
        }
      }

    case remote_followed_groups_1.default.UNFOLLOW_SUCCESS:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_unfollow: false,
            user_follow_status: followed_status_1.default.NOT_FOLLOWED
          });
        } else {
          return state;
        }
      }

    case remote_followed_groups_1.default.UNFOLLOW_FAILURE:
      {
        if (!!state.group && state.group.id === action.group_id) {
          return Object.assign({}, state, {
            is_loading_unfollow: false
          });
        } else {
          return state;
        }
      }

    case remote_items_1.default.UPDATE_OWNER_MENU_INDEX:
      return Object.assign({}, state, {
        owner_menu_index: action.index
      });

    case remote_items_1.default.UPDATE_USERS_QUICK_FILTER_OPTIONS:
      return Object.assign({}, state, {
        quick_filter_options: action.options
      });

    case remote_items_1.default.RELOAD_INIT:
      return Object.assign({}, state, {
        is_reloading: true,
        list: [],
        user_follow_status: followed_status_1.default.IDEL,
        owner_pending_list: []
      });

    case remote_items_1.default.RELOAD_SUCCESS:
      return Object.assign({}, state, {
        is_reloading: false,
        list: action.list,
        user_follow_status: action.followed_status,
        owner_pending_list: action.owner_pending_list,
        view: action.view,
        owner_menu_index: action.owner_menu_index,
        quick_filter_options: action.quick_filter_options
      });

    case remote_items_1.default.RELOAD_FAILURE:
      return Object.assign({}, state, {
        is_reloading: false
      });

    case remote_items_filter_1.default.CONFIRM_SUCCESS:
      {
        return Object.assign({}, state, {
          filter_selected: action.selected,
          filter_user_inputs: action.user_inputs
        });
      }

    case remote_items_filter_1.default.RESET:
      {
        return Object.assign({}, state, {
          filter_selected: [],
          filter_user_inputs: []
        });
      }

    case remote_items_1.default.ADD_INIT:
      return Object.assign({}, state, {
        is_loading_add: true
      });

    case remote_items_1.default.ADD_SUCCESS:
      {
        return Object.assign({}, state, {
          list: action.list,
          is_loading_add: false
        });
      }

    case remote_items_1.default.ADD_FAILURE:
      return Object.assign({}, state, {
        is_loading_add: false,
        error_on_add: action.error
      });

    case remote_items_1.default.CONTRIBUTE_INIT:
      return Object.assign({}, state, {
        is_loading_contribute: true
      });

    case remote_items_1.default.CONTRIBUTE_SUCCESS:
      {
        return Object.assign({}, state, {
          list: action.list,
          is_loading_contribute: false
        });
      }

    case remote_items_1.default.CONTRIBUTE_FAILURE:
      return Object.assign({}, state, {
        is_loading_contribute: false,
        error_on_contribute: action.error
      });

    case remote_items_1.default.EDIT_INIT:
      return Object.assign({}, state, {
        is_loading_edit: true
      });

    case remote_items_1.default.EDIT_SUCCESS:
      {
        return Object.assign({}, state, {
          is_loading_edit: false,
          list: action.list
        });
      }

    case remote_items_1.default.EDIT_FAILURE:
      return Object.assign({}, state, {
        is_loading_edit: false
      });

    case remote_items_1.default.RESUBMIT_INIT:
      return Object.assign({}, state, {
        is_loading_resubmit: true,
        error_on_resubmit: null
      });

    case remote_items_1.default.RESUBMIT_SUCCESS:
      {
        var itemData = action.item_data;
        var groupData = action.group_data;
        var curGroupData = state.group;

        if (!!curGroupData && !!groupData && curGroupData.id === groupData.id) {
          return Object.assign({}, state, {
            is_loading_resubmit: false,
            list: UtilsArray.replaceByProps(state.list, {
              id: action.item_id
            }, action.item_data)
          });
        } else {
          return state;
        }
      }

    case remote_items_1.default.RESUBMIT_FAILURE:
      {
        return Object.assign({}, state, {
          is_loading_resubmit: false,
          error_on_resubmit: action.error
        });
      }

    case remote_items_1.default.REMOVE_INIT:
      return Object.assign({}, state, {
        is_loading_remove: true
      });

    case remote_items_1.default.REMOVE_SUCCESS:
      {
        var list = lodash_1.default.filter(state.list, function (u) {
          return u.id !== action.item_id;
        });
        return Object.assign({}, state, {
          is_loading_remove: false,
          list: list
        });
      }

    case remote_items_1.default.REMOVE_FAILURE:
      return Object.assign({}, state, {
        is_loading_remove: false
      });

    case remote_items_1.default.DETACH_INIT:
      return Object.assign({}, state, {
        is_loading_detach: true
      });

    case remote_items_1.default.DETACH_SUCCESS:
      {
        var _list = lodash_1.default.filter(state.list, function (u) {
          return u.id !== action.item_id;
        });

        return Object.assign({}, state, {
          is_loading_detach: false,
          list: _list
        });
      }

    case remote_items_1.default.DETACH_FAILURE:
      return Object.assign({}, state, {
        is_loading_detach: false
      });

    case remote_item_review_1.default.APPROVE_SUCCESS:
      {
        var item = action.item;

        if (!item) {
          return state;
        }

        var owner_pending_list = UtilsArray.removeByProps(state.owner_pending_list, {
          id: item.id
        });
        var itemGroupId = item.group_id;
        var _list2 = state.list;

        if (state.group && state.group.id === itemGroupId) {
          _list2 = UtilsArray.unshift(state.list, item);
        }

        var owner_menu_index = state.owner_menu_index;

        if (owner_pending_list.length === 0) {
          owner_menu_index = 0;
        }

        return Object.assign({}, state, {
          list: _list2,
          owner_pending_list: owner_pending_list,
          owner_menu_index: owner_menu_index
        });
      }

    case remote_item_review_1.default.REJECT_SUCCESS:
      {
        var _item = action.item;

        if (!_item) {
          return state;
        }

        var _owner_pending_list = UtilsArray.removeByProps(state.owner_pending_list, {
          id: _item.id
        });

        var _owner_menu_index = state.owner_menu_index;

        if (_owner_pending_list.length === 0) {
          _owner_menu_index = 0;
        }

        return Object.assign({}, state, {
          owner_pending_list: _owner_pending_list,
          owner_menu_index: _owner_menu_index
        });
      }

    case remote_item_review_1.default.ON_UPDATE:
      {
        var item_id = action.item_id;
        var isInList = lodash_1.default.find(state.list, {
          id: item_id
        });
        var isInPendingList = lodash_1.default.find(state.owner_pending_list, {
          id: item_id
        });

        if (!isInList && !isInPendingList) {
          return state;
        }

        var _item2 = action.item;
        var curList = state.list;
        var curPendingList = state.owner_pending_list;

        if (_item2) {
          if (isInList) {
            return Object.assign({}, state, {
              list: UtilsArray.replaceByProps(state.list, {
                id: item_id
              }, _item2)
            });
          } else if (isInPendingList) {
            if (_item2.group_id === null || _item2.approve_state !== remote_item_approve_state_1.default.PENDING) {
              var pendings = UtilsArray.removeByProps(state.owner_pending_list, {
                id: item_id
              });
              return Object.assign({}, state, {
                owner_menu_index: pendings.length === 0 ? 0 : state.owner_menu_index,
                owner_pending_list: pendings
              });
            } else {
              return state;
            }
          }
        } else {
          var _owner_menu_index2 = state.owner_menu_index;

          var _owner_pending_list2 = UtilsArray.removeByProps(state.owner_pending_list, {
            id: item_id
          });

          return Object.assign({}, state, {
            list: UtilsArray.removeByProps(state.list, {
              id: item_id
            }),
            owner_menu_index: _owner_pending_list2.length === 0 ? 0 : _owner_menu_index2,
            owner_pending_list: _owner_pending_list2
          });
        }
      }

    case remote_groups_1.default.ON_GROUP_UPDATE:
      {
        var curGroup = state.group;
        var nextGroup = action.data;
        var group_id = action.group_id;

        if (curGroup && curGroup.id === group_id) {
          return Object.assign({}, state, {
            group: nextGroup
          });
        } else {
          return state;
        }
      }

    case app_1.default.ON_NOTI_ITEM_APPROVED:
    case app_1.default.ON_NOTI_ITEM_REJECTED:
      {
        var _item_id = action.item_id;

        var _owner_pending_list3 = UtilsArray.removeByProps(state.owner_pending_list, {
          id: _item_id
        });

        return Object.assign({}, state, {
          owner_pending_list: _owner_pending_list3,
          owner_menu_index: _owner_pending_list3.length === 0 ? 0 : state.owner_menu_index
        });
      }

    case remote_item_edit_1.default.ADD_SUCCESS:
    case remote_item_edit_1.default.CONTRIBUTE_SUCCESS:
      {
        var _item3 = action.item,
            _group_id = action.group_id;
        var group = state.group;

        if (group && group.id === _group_id && _item3) {
          return Object.assign({}, state, {
            list: lodash_1.default.unionBy(UtilsArray.unshift(state.list, _item3), 'id')
          });
        } else {
          return state;
        }
      }

    case remote_item_edit_1.default.EDIT_SUCCESS:
      {
        var _item4 = action.item;
        var _group = state.group;

        if (_group && _item4 && _group.id === _item4.group_id) {
          return Object.assign({}, state, {
            list: UtilsArray.replaceByProps(state.list, {
              id: _item4.id
            }, _item4)
          });
        } else {
          return state;
        }
      }

    case remote_items_1.default.SELECT_VIEW_TYPE:
      return Object.assign({}, state, {
        view: action.view_type
      });

    case remote_items_1.default.SELECT_SORT:
      return Object.assign({}, state, {
        sort: action.sort
      });

    case auth_1.default.SIGN_OUT_SUCCESS:
    case remote_items_1.default.CLEAR:
      return Object.assign({}, state, {
        list: [],
        group: null,
        user_follow_status: followed_status_1.default.IDEL,
        owner_pending_list: [],
        owner_menu_index: 0,
        error_on_get_list: null,
        error_on_add: null,
        error_on_reload: null,
        error_on_contribute: null,
        is_loading: false,
        is_reloading: false,
        is_loading_add: false,
        is_loading_contribute: false,
        is_loading_edit: false,
        is_loading_remove: false,
        is_loading_detach: false,
        is_loading_review: false,
        is_loading_resubmit: false,
        is_loading_follow: false,
        is_loading_unfollow: false,
        is_loading_check_follow: false,
        filter_selected: [],
        filter_user_inputs: [],
        query: '',
        view: row_view_type_1.default.REGULAR,
        sort: items_sort_reserved_words_1.default.EDIT_AT,
        quick_filter_options: []
      });

    case remote_items_1.default.SEARCH:
      return Object.assign({}, state, {
        query: action.query
      });

    default:
      return state;
  }
}

exports.default = default_1;